module.exports = __webpack_public_path__ + "img/WX20200416-112206@2x.71e288b5.jpg";